import React, { useState, useEffect } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function KnowledgeBases() {
  const [kbs, setKbs] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', content: '' });
  const load = async () => { const { data } = await api.get('/agents/knowledge-bases'); setKbs(data); };
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (editing === 'new') await api.post('/agents/knowledge-bases', form);
    else await api.put(`/agents/knowledge-bases/${editing.id}`, form);
    setEditing(null); await load();
  };
  const del = async (id, name) => {
    if (!window.confirm(`Удалить базу знаний «${name}»?`)) return;
    await api.delete(`/agents/knowledge-bases/${id}`); await load();
  };

  if (editing !== null) return (
    <div style={{ padding: 32, maxWidth: 800 }}>
      <button onClick={() => setEditing(null)} style={btnGhost}>← Назад</button>
      <h2 style={{ fontSize: 18, fontWeight: 600, margin: '16px 0 20px' }}>{editing === 'new' ? 'Новая база знаний' : `Редактировать: ${editing.name}`}</h2>
      <input placeholder="Название" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} />
      <div style={{ fontSize: 13, color: '#888', marginBottom: 6 }}>Вставьте FAQ, описание продуктов, условия — всё что агент должен знать</div>
      <textarea value={form.content} onChange={e => setForm(f => ({ ...f, content: e.target.value }))} rows={22} style={{ ...inp, fontFamily: 'monospace', fontSize: 13, resize: 'vertical' }} />
      <div style={{ fontSize: 12, color: '#aaa', marginBottom: 12 }}>{form.content.length} символов</div>
      <div style={{ display: 'flex', gap: 8 }}><button onClick={save} style={btnPrimary}>Сохранить</button><button onClick={() => setEditing(null)} style={btnGhost}>Отмена</button></div>
    </div>
  );

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>База знаний</h1>
        <button onClick={() => { setForm({ name: '', content: '' }); setEditing('new'); }} style={btnPrimary}>+ Новая база</button>
      </div>
      {kbs.length === 0 && <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>Баз знаний нет.</div>}
      <div style={{ display: 'grid', gap: 10 }}>
        {kbs.map(k => (
          <div key={k.id} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 20 }}>📚</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{k.name}</div>
              <div style={{ fontSize: 12, color: '#aaa' }}>{k.content?.length || 0} символов</div>
            </div>
            <button onClick={() => { setForm({ name: k.name, content: k.content }); setEditing(k); }} style={btnGhost}>Редактировать</button>
            <button onClick={() => del(k.id, k.name)} style={btnDanger}>🗑</button>
          </div>
        ))}
      </div>
    </div>
  );
}
